import React from "react";
import TwoCol from "../../containers/twoCol";
import FlexText from "../../flexText";
import TitleBar from "../../titleBar";
import Image from "../../image/image";

const ImageWithDescription = ({
  Styles,
  row,
  linkColor,
  title,
  padding,
  colHeight,
  bgColor,
  ImageBG,

  left,
  field_boolean_2,
  titleStyles,
  attributes,
  item,
}) => (
  <TwoCol
    className={"iwd  " + linkColor}
    styles={{
      height: colHeight,
      backgroundColor: bgColor,
      ...ImageBG,
      position: "relative",

      padding: padding,
      width: window.innerWidth > 899 ? "50%" : "100vw",
    }}
  >
    {left && field_boolean_2 === "1" ? (
      <TitleBar
        divStyle={{
          ...Styles.divStyle,
          top: "36px",
          left: "24px",
          marginLeft: "0",
          marginBottom: "32px",
        }}
        color={titleStyles.field_color_1}
        bgc={titleStyles.field_bgcolor_1}
        fontFamily={titleStyles.field_font_1.name}
        max="19"
        min="16"
        container="Left"
        tag="h2"
      >
        {title}
      </TitleBar>
    ) : null}
    {window.innerWidth < 900 ? (
      <div style={{ width: "100vw", marginLeft: "-24px" }}>
        <Image media={row.field_image} className="image" alt="" />
      </div>
    ) : (
      <Image media={row.field_image} className="image" alt="" />
    )}

    {typeof row.field_text_1 !== "undefined" ? (
      <FlexText
        color={attributes.field_heading_color_font[0].field_color_1}
        tag="h3"
        max="32"
        min="28"
        styles={{
          textTransform: "uppercase",
          fontWeight: "normal",
          fontFamily: "Oswald, sans-serif",
          textAlign: "left",

          textDecoration: "none",

          color: attributes.field_heading_color_font[0].field_color_1,
        }}
      >
        {row.field_text_1}
      </FlexText>
    ) : null}
    {typeof row.field_longtext_1 !== "undefined" ? (
      <FlexText
        tag="p"
        color={attributes.field_text_color_font[0].field_color_1}
        max="16"
        min="14"
        styles={{
          fontFamily: "Roboto",
          textTransform: "none",
        }}
      >
        {row.field_longtext_1}
      </FlexText>
    ) : null}
  </TwoCol>
);

export default ImageWithDescription;
